// src/components/Skills.tsx
import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

const Skills: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Skills
      </Typography>
      <Typography paragraph>
        List of technical and soft skills.
      </Typography>
    </Box>
  );
}

export default Skills;
